import { render, staticRenderFns } from "./carient.vue?vue&type=template&id=23fcb6d8"
import script from "./carient.vue?vue&type=script&lang=js"
export * from "./carient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports